export default {
  apple: "https://apps.apple.com/fr/app/beauty-genius-by-shiseido/id1478243233",
  android:
    "https://play.google.com/store/apps/details?id=app.shiseido.beautygenius",
};
